export default function ServiceAreas() {
  return (
    <section className="bg-[#f5f4f0] py-24 px-6 md:px-16 lg:px-24">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Left */}
        <div>
          <div className="inline-flex items-center gap-2 mb-6">
            <div className="w-8 h-px bg-[#C9A84C]"></div>
            <span className="font-inter text-[#C9A84C] text-xs tracking-widest uppercase">Service Area</span>
          </div>
          <h2 className="font-barlow-condensed font-900 text-[#1a1a1a] text-4xl md:text-5xl leading-none mb-6">
            SERVING LAS VEGAS<br /><span className="text-[#C9A84C]">&amp; SURROUNDING AREAS</span>
          </h2>
          <p className="font-inter text-[#1a1a1a]/60 text-sm leading-relaxed mb-8 max-w-md">
            We provide post-construction cleaning in Las Vegas and commercial cleaning services in Las Vegas for contractors, builders, and property managers across the greater Las Vegas area.
          </p>
          <div className="flex flex-col gap-3 mb-8">
            {[
              'Post-construction cleaning in Las Vegas',
              'Commercial cleaning services in Las Vegas',
              'Jobsite cleanup across Las Vegas, NV',
              'Final cleaning for Las Vegas construction projects',
              'Debris removal for Las Vegas builders',
            ].map((item) => (
              <div key={item} className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-map-pin-line text-[#C9A84C] text-sm"></i>
                </div>
                <span className="font-inter text-[#1a1a1a]/70 text-sm">{item}</span>
              </div>
            ))}
          </div>

          {/* GBP link */}
          <a
            href="https://www.google.com/maps/place/Quiroz+Construction+Cleaning,+LLC/data=!4m2!3m1!1s0x0:0x58b3b1b7f9c6b9bb?sa=X&ved=1t:2428&ictx=111"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#1a1a1a] hover:bg-[#2a2a2a] text-white font-barlow font-700 text-sm px-6 py-3 rounded-sm transition-all duration-200 cursor-pointer whitespace-nowrap tracking-wide"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-google-fill text-[#C9A84C] text-base"></i>
            </div>
            View on Google Business Profile
            <i className="ri-external-link-line text-white/40 text-sm"></i>
          </a>
        </div>

        {/* Right - Map embed */}
        <div className="flex flex-col gap-4">
          <div className="rounded-sm overflow-hidden border border-[#1a1a1a]/10" style={{ height: '420px' }}>
            <iframe
              title="Quiroz Construction Cleaning LLC - Las Vegas Google Business Profile"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3223.123456789!2d-115.1728484!3d36.1147065!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x58b3b1b7f9c6b9bb!2sQuiroz%20Construction%20Cleaning%2C%20LLC!5e0!3m2!1sen!2sus!4v1680000000001!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          {/* GBP trust badge */}
          <div className="flex items-center gap-3 bg-white border border-[#1a1a1a]/8 rounded-sm px-5 py-3">
            <div className="w-8 h-8 flex items-center justify-center shrink-0">
              <i className="ri-google-fill text-[#C9A84C] text-xl"></i>
            </div>
            <div>
              <div className="font-barlow font-700 text-[#1a1a1a] text-sm">Quiroz Construction Cleaning, LLC</div>
              <div className="font-inter text-[#1a1a1a]/50 text-xs">Verified Google Business Profile · Las Vegas, NV</div>
            </div>
            <div className="ml-auto flex gap-0.5">
              {[1,2,3,4,5].map((s) => (
                <i key={s} className="ri-star-fill text-[#C9A84C] text-xs"></i>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
